import * as _types2 from "@near-js/types";
var _types = "default" in _types2 ? _types2.default : _types2;
import * as _borsh2 from "borsh";
var _borsh = "default" in _borsh2 ? _borsh2.default : _borsh2;
import * as _tweetnacl2 from "tweetnacl";
var _tweetnacl = "default" in _tweetnacl2 ? _tweetnacl2.default : _tweetnacl2;
import _constants from "./constants";
var exports = {};
var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PublicKey = void 0;
const types_1 = _types;
const borsh_1 = _borsh;
const tweetnacl_1 = __importDefault(_tweetnacl);
const constants_1 = _constants;
function key_type_to_str(keyType) {
  switch (keyType) {
    case constants_1.KeyType.ED25519:
      return "ed25519";
    default:
      throw new Error(`Unknown key type ${keyType}`);
  }
}
function str_to_key_type(keyType) {
  switch (keyType.toLowerCase()) {
    case "ed25519":
      return constants_1.KeyType.ED25519;
    default:
      throw new Error(`Unknown key type ${keyType}`);
  }
}
/**
 * PublicKey representation that has type and bytes of the key.
 */
class PublicKey extends types_1.Assignable {
  static from(value) {
    if (typeof value === "string") {
      return PublicKey.fromString(value);
    }
    return value;
  }
  static fromString(encodedKey) {
    const parts = encodedKey.split(":");
    let publicKey;
    let keyType = constants_1.KeyType.ED25519;
    if (parts.length === 1) {
      publicKey = parts[0];
    } else if (parts.length === 2) {
      publicKey = parts[1];
      keyType = str_to_key_type(parts[0]);
    } else {
      throw new Error("Invalid encoded key format, must be <curve>:<encoded key>");
    }
    const decodedPublicKey = (0, borsh_1.baseDecode)(publicKey);
    if (decodedPublicKey.length !== tweetnacl_1.default.box.publicKeyLength) {
      throw new Error(`Invalid public key size (${decodedPublicKey.length}), must be ${tweetnacl_1.default.box.publicKeyLength}`);
    }
    return new PublicKey({
      keyType,
      data: decodedPublicKey
    });
  }
  toString() {
    return `${key_type_to_str(this.keyType)}:${(0, borsh_1.baseEncode)(this.data)}`;
  }
  verify(message, signature) {
    switch (this.keyType) {
      case constants_1.KeyType.ED25519:
        return tweetnacl_1.default.sign.detached.verify(message, signature, this.data);
      default:
        throw new Error(`Unknown key type ${this.keyType}`);
    }
  }
}
exports.PublicKey = PublicKey;
export default exports;